/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import HeaderContext from 'header_context';

$('body').on('click', '.js--contact-form', function(e) {
  e.preventDefault();

  const promise = HeaderContext.switch(HeaderContext.MODAL);
  if (promise) {
    // wait for dropdown/sidebar to close
    return promise.then(() => {
      return openModal();
    });
  } else {
    // If there's no sidebar on the page, then
    return openModal();
  }
});

var openModal = function() {
  if (window.Beacon) {
    return window.Beacon('open');
  } else {
    return window.location.assign('https://help.mubi.com');
  }
};
